import React, { useEffect } from 'react';
import PlaylistCard from './PlaylistCard';
import PropTypes from 'prop-types';
import { useFetchVideos } from '@entertainment-ai/mansueto';

const VideoSkeleton = () => (
  <div className="card loading">
    <div className="metadata-container">
      <div className="card__eyebrow" />
      <div className="card__title" />
    </div>
    <div className="card__image_container" />
  </div>
);

const VideoPlaylistLoading = ({ limit }) => (
  <>{[...Array(limit)].map((a, i) => <VideoSkeleton key={i} />)}</>
);

// eslint-disable-next-line no-unused-vars
const Playlist = ({ currentVideoId, tags, limit }) => {
  const [filteredVideos, setFilteredVideos] = React.useState([]);

  const { videos, loading } = useFetchVideos({
    tags,
    apiKey: process.env.SEEN_KEY || '',
    apiUrl: process.env.SEEN_API_URL || '',
    thumbnailSizes: [
      {
        width: 229,
        height: 129
      },
      {
        width: 673,
        height: 379
      },
      {
        width: 420,
        height: 236
      }
    ]
  });

  // Filter the current video out of the playlist & limit # of results
  useEffect(
    () => {
      if (!videos) return;

      const filtered = videos.filter(video => video.id !== currentVideoId);
      setFilteredVideos([...filtered].slice(0, limit));
    },
    [videos]
  );

  return (
    <section className="playlist_container full">
      <h2 className="playlist_title">More Videos</h2>
      <div className="playlist_container__videos">
        {loading && <VideoPlaylistLoading limit={limit} />}
        {!loading && !videos && <p>There was an error loading the videos.</p>}
        {!loading &&
          filteredVideos &&
          filteredVideos.map(item => (
            <PlaylistCard key={item.id} item={item} />
          ))}
      </div>
    </section>
  );
};

Playlist.defaultProps = {
  currentVideoId: '',
  limit: 12
};

Playlist.propTypes = {
  currentVideoId: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  limit: PropTypes.number
};

export default Playlist;
